import { AutomateNavigationItemId } from 'constants/automate/constants';
import { type SettingsNavigationItemId } from 'constants/settings/navigation-item-id';
import { filterActiveKnowledgeSources } from 'helpers/knowledge-hub';
import { isSourceFileType } from 'helpers/knowledge-hub/knowledge-hub';
import { type KnowledgeSourceItem, KnowledgeSourceType } from 'interfaces/knowledge-sources';
import { AppStateProvider } from 'services/app-state-provider';
import { getPublicKnowledgeSourceIds } from 'store/entities/ai-agents/selectors';
import { getCanUseCopilotPopover } from 'store/views/copilot/selectors';

export const getSourcesCountByType = (
  itemId: SettingsNavigationItemId | AutomateNavigationItemId,
  data?: KnowledgeSourceItem[],
): number => {
  if (!data) {
    return 0;
  }

  // NOTE: Copilot chat is deprecated in its current form,
  // therefore the `internal` knowledge type is no longer supported.
  // Pre-existing internal knowledge sources are not counted.
  const canUseCopilotChat = AppStateProvider.selectFromStore(getCanUseCopilotPopover);
  const publicSourceIds = AppStateProvider.selectFromStore(getPublicKnowledgeSourceIds);
  const activeItems = canUseCopilotChat
    ? filterActiveKnowledgeSources(data)
    : filterActiveKnowledgeSources(data).filter((source) => publicSourceIds.includes(source.id));

  if (itemId === AutomateNavigationItemId.KnowledgeHubAllSources) {
    return activeItems.length;
  }

  if (itemId === AutomateNavigationItemId.KnowledgeHubWebsites) {
    return activeItems.filter((source) => source.sourceType === KnowledgeSourceType.URL).length;
  }

  if (itemId === AutomateNavigationItemId.KnowledgeHubPDF) {
    return activeItems.filter(isSourceFileType).filter(({ fileType }) => fileType === 'PDF').length;
  }

  return 0;
};
